import { API } from 'widget/helpers/axios';

const buildUrl = endPoint => `/api/v1/${endPoint}`;

export default {
  get() {
    return API.get(buildUrl('widget/contact'));
  },
  update(identifier, userObject) {
    return API.patch(buildUrl('widget/contact'), {
      identifier,
      ...userObject,
    });
  },
  setCustomAttibutes(customAttributes = {}) {
    return API.patch(buildUrl('widget/contact'), {
      custom_attributes: customAttributes,
    });
  }
};
